import { Link } from "react-router-dom";
import type { Movie } from "@/types/content";

interface MovieCardProps {
  movie: Movie;
  index?: number;
}

export default function MovieCard({ movie, index = 0 }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-secondary-900">
        <img
          src={movie.poster}
          alt={`${movie.title}剧照海报，${movie.year}年${movie.genres.join("、")}题材影视剧`}
          title={`${movie.title} - 剧情解析与推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/10 to-transparent" />
        <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 font-label text-xs font-bold text-primary-950">
          <i className="ri-star-fill text-[11px]" aria-hidden="true" />
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute right-3 top-3 rounded-md bg-primary-950/60 px-2 py-1 text-[11px] text-background-100 backdrop-blur-sm">
          {movie.region}
        </span>
        <div className="absolute bottom-3 left-3 right-3">
          <h3 className="font-heading text-base font-bold text-background-50 line-clamp-1 md:text-lg">{movie.title}</h3>
          <p className="mt-1 text-xs text-background-200 line-clamp-1">
            {movie.year} · {movie.genres.join(" / ")} · {movie.episodes}集
          </p>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <p className="text-sm leading-6 text-foreground-600 line-clamp-2">{movie.summary}</p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-4">
          {movie.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-900"
            >
              {tag}
            </span>
          ))}
          <span className="ml-auto flex items-center gap-1 text-xs font-medium text-primary-700 transition-colors group-hover:text-accent-600">
            剧情解析
            <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
          </span>
        </div>
      </div>
    </Link>
  );
}